module.exports = __webpack_public_path__ + "static/media/fold2.5d7315fe.jpg";